import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error('ERP crash:', error, info); }
  render() {
    if (this.state.error) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F5FAFC', padding: 24, fontFamily: 'system-ui, sans-serif' }}>
          <div style={{ maxWidth: 480, background: '#fff', border: '1px solid #E3EEF2', borderRadius: 16, padding: 24, boxShadow: '0 8px 30px rgba(46,134,171,.12)' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>⚠️</div>
            <h2 style={{ margin: '0 0 8px', fontSize: 16, color: '#201F1E' }}>Ocorreu um erro</h2>
            <p style={{ fontSize: 12, color: '#605E5C', marginBottom: 12 }}>Tira um print desta mensagem e envia — isto ajuda a corrigir rápido.</p>
            <pre style={{ fontSize: 11, background: '#FDE7E9', color: '#8A1D1D', padding: 10, borderRadius: 8, overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {String(this.state.error?.message || this.state.error)}
            </pre>
            <button
              onClick={() => window.location.reload()}
              style={{ marginTop: 14, background: '#2E86AB', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}
            >
              Recarregar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><ErrorBoundary><App /></ErrorBoundary></React.StrictMode>);
